const Styles = {
    'CheckboxInput': 'CheckboxInput_CheckboxInput--009d71ae',
    'CheckboxLabel': 'CheckboxInput_CheckboxLabel--cabbc1eb',
    'CheckboxLabelText': 'CheckboxInput_CheckboxLabelText--54fd2225',
    'CheckboxContainer': 'CheckboxInput_CheckboxContainer--646f2cb6'
};

export default Styles;